import { ChangeDetectionStrategy, Component, inject, AfterViewInit, OnDestroy, TemplateRef, viewChild } from '@angular/core';

import { PageHeaderService } from '../page-header-service';

@Component({
  selector: 'ciphr-page-header-title',
  standalone: true,
  templateUrl: './page-header-title.component.html',
  styleUrls: ['./page-header-title.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PageHeaderTitleComponent implements AfterViewInit, OnDestroy {
  private readonly pageHeaderService = inject(PageHeaderService);

  private readonly templateRef = viewChild.required(TemplateRef);

  ngAfterViewInit(): void {
    this.pageHeaderService.setTitleTemplate(this.templateRef());
  }

  ngOnDestroy() {
    this.pageHeaderService.resetTitleTemplate();
  }
}
